import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import { Navbar, NavDropdown, NavItem } from 'react-bootstrap';
import { LinkContainer } from "react-router-bootstrap";

import { faHome, faLock, faUnlock, faMobileAlt, faBars } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import PropTypes from 'prop-types';

class Header extends React.Component {
	constructor(props) {
		super(props);
		
		this.app = this.props.app;
		this.getMvcModuleObject = this.app.getMvcModuleObject;

		this.closing = false;
		
		this.state = {
			isLoggedIn: false,
			hasOpenWallet: false,
			isdevicewallet: false
		}
	}	

	// post render commit phase
	componentDidUpdate(prevProps, prevState) {
		console.log('Header.componentDidUpdate called');

		if (this.props.currentwalletuuid) {
			let rootsessionuuid = this.props.rootsessionuuid;
			let walletuuid = this.props.currentwalletuuid;
			
			// check if wallet it is not the device wallet
			if (walletuuid && (this.state.isdevicewallet !== true))
			this.app.isDeviceWallet(walletuuid)		
			.then((isdevicewallet) => {
				if ((this.closing !== true) && (isdevicewallet === true))
				this.setState({isdevicewallet});
			})
			.catch(err => {
				console.log('error in Header.componentDidUpdate: ' + err);
			});
		}
	}
		
	componentDidMount() {
		console.log('Header.componentDidMount called');

		this.app.checkWalletUnlocked()
		.then((unlocked) => {
			return unlocked;
		})
		.catch(err => {
			console.log('error in Header.componentDidMount: ' + err);
		});

	}

	// end of life
	componentWillUnmount() {
		this.closing = true;
	}

	// render
	renderLock() {
		const {hasOpenWallet, isdevicewallet} = this.state;

		return (
			<span>
			{(hasOpenWallet === true ? 
			<span className="Lock">
			<FontAwesomeIcon className="LockIcon" icon={faUnlock} /> 
			{(isdevicewallet === true ? <FontAwesomeIcon className="DeviceIcon" icon={faMobileAlt} /> : <></>)} </span> : 
			<FontAwesomeIcon className="LockIcon" icon={faLock} />)}
			</span>
		);


	}

	render() {
		const {hasOpenWallet} = this.state;
		const appconfig = this.app.getConfig();
		const routesconfig = (appconfig.routes ? appconfig.routes : {});
		const hasquotes = (routesconfig.quotes && (routesconfig.quotes.disabled === true) ? false : true);
		const hasbounties = (routesconfig.bounties && (routesconfig.bounties.disabled === true) ? false : true);

		return (
			<div className='Header'>
				<Navbar bg="light" variant="light" expand="lg">
					<Navbar.Brand>
						<Link to="/"><FontAwesomeIcon icon={faHome} /></Link>
					</Navbar.Brand>
					{this.renderLock()}
					<NavDropdown title={<FontAwesomeIcon icon={faBars} />} id="basic-nav-dropdown">
								{(hasOpenWallet === true ? 
								<></> : 
								<LinkContainer to="/login"><NavDropdown.Item  onClick={() => {this.app.gotoRoute('login');}}>Login</NavDropdown.Item></LinkContainer>)}
								<LinkContainer to="/logout"><NavDropdown.Item>Logout</NavDropdown.Item></LinkContainer>

								{(hasquotes ?
								<>
								<NavDropdown.Divider />
								<LinkContainer to="/quote"><NavDropdown.Item onClick={() => {this.app.gotoRoute('quote', {action: "create"});}}>Create Quote</NavDropdown.Item></LinkContainer>
								<LinkContainer to="/quotes"><NavDropdown.Item>Quotes</NavDropdown.Item></LinkContainer>
								<LinkContainer to="/orders"><NavDropdown.Item>Orders</NavDropdown.Item></LinkContainer>
								<LinkContainer to="/invoices"><NavDropdown.Item>Invoices</NavDropdown.Item></LinkContainer>
								<LinkContainer to="/paymentnotices"><NavDropdown.Item>Payment Notices</NavDropdown.Item></LinkContainer>
								</>:
								<></>)}

								{(hasbounties ?
								<>
								<NavDropdown.Divider />
								<LinkContainer to="/bounty"><NavDropdown.Item onClick={() => {this.app.gotoRoute('bounty', {action: "create"});}}>Create Bounty</NavDropdown.Item></LinkContainer>
								<LinkContainer to="/bounties"><NavDropdown.Item>Bounties</NavDropdown.Item></LinkContainer>
								<LinkContainer to="/claims"><NavDropdown.Item>Claims</NavDropdown.Item></LinkContainer>
								</>:
								<></>)}


								<NavDropdown.Divider />
								<LinkContainer to="/currencycards"><NavDropdown.Item>Currency Cards</NavDropdown.Item></LinkContainer>
								<NavDropdown.Divider />
								<LinkContainer to="/deeplink"><NavDropdown.Item>Enter url</NavDropdown.Item></LinkContainer>
								<NavDropdown.Divider />
								<LinkContainer to="/datawipe"><NavDropdown.Item>Wipe all data</NavDropdown.Item></LinkContainer>
								<NavDropdown.Divider />
								<LinkContainer to="/about"><NavDropdown.Item >About</NavDropdown.Item></LinkContainer>
					</NavDropdown>
				</Navbar>
			</div>
		);
	}
	 
	static getDerivedStateFromProps(nextProps, prevState) {
		// fill state
		return {
			isLoggedIn: nextProps.isLoggedIn,
			hasOpenWallet: ((nextProps.currentwalletuuid) && (nextProps.iswalletlocked === false) ? true : false),
		};
	}
}

// propTypes validation
Header.propTypes = {
	app: PropTypes.object.isRequired,
	rootsessionuuid: PropTypes.string,
	isLoggedIn: PropTypes.bool,
	lastLoggedInCheck: PropTypes.number,
	loggedInCheckPending: PropTypes.bool,
	currentwalletuuid: PropTypes.string,
	unlockpending: PropTypes.bool,
	iswalletlocked: PropTypes.bool,
};

//redux
const mapStateToProps = (state) => {
	return {
		rootsessionuuid: state.session.sessionuuid,
		isLoggedIn: state.login.success,
		loggedInCheckPending: state.login.checkpending,
		lastLoggedInCheck: state.login.checkedon,
		currentwallet: state.wallets.walletname,
		currentwalletuuid: state.wallets.walletuuid,
		unlockpending: state.wallets.openpending,
		iswalletlocked: state.wallets.islocked,
	};
}

const mapDispatchToProps = (dispatch) => {
	return {
	};
}

export {Header};
export default connect(mapStateToProps, mapDispatchToProps)(Header);